
// template: import cssIcon from "../../assets/icons/css.svg"
// autogenerated script fyi
import bashIcon from "../../assets/icons/bash.svg"
import bunIcon from "../../assets/icons/bun.svg"
import coffeescriptIcon from "../../assets/icons/coffeescript.svg"
import cppIcon from "../../assets/icons/cpp.svg"
import csharpIcon from "../../assets/icons/csharp.svg"
import cssIcon from "../../assets/icons/css.svg"
import dockerIcon from "../../assets/icons/docker.svg"
import ejsIcon from "../../assets/icons/ejs.svg"
import figmaIcon from "../../assets/icons/figma.svg"
import folder_cloudIcon from "../../assets/icons/folder_cloud.svg"
import folder_cloud_openIcon from "../../assets/icons/folder_cloud_open.svg"
import gitIcon from "../../assets/icons/git.svg"
import graphqlIcon from "../../assets/icons/graphql.svg"
import htmlIcon from "../../assets/icons/html.svg"
import javascriptIcon from "../../assets/icons/javascript.svg"
import javascriptReactIcon from "../../assets/icons/javascriptReact.svg"
import jsonIcon from "../../assets/icons/json.svg"
import nextIcon from "../../assets/icons/next.svg"
import nodejsIcon from "../../assets/icons/nodejs.svg"
import npmIcon from "../../assets/icons/npm.svg"
import pnpmIcon from "../../assets/icons/pnpm.svg"
import prismaIcon from "../../assets/icons/prisma.svg"
import puppeteerIcon from "../../assets/icons/puppeteer.svg"
import pythonIcon from "../../assets/icons/python.svg"
import reactjsIcon from "../../assets/icons/reactjs.svg"
import robotsIcon from "../../assets/icons/robots.svg"
import sassIcon from "../../assets/icons/sass.svg"
import tailwindIcon from "../../assets/icons/tailwind.svg"
import typescriptIcon from "../../assets/icons/typescript.svg"
import vercelIcon from "../../assets/icons/vercel.svg"
import visualStudioIcon from "../../assets/icons/visualStudio.svg"
import vscodeIcon from "../../assets/icons/vscode.svg"
import yarnIcon from "../../assets/icons/yarn.svg"

export const bash = bashIcon;
export const bun = bunIcon;
export const coffeescript = coffeescriptIcon;
export const cpp = cppIcon;
export const csharp = csharpIcon;
export const css = cssIcon;
export const docker = dockerIcon;
export const ejs = ejsIcon;
export const figma = figmaIcon;
export const folder_cloud = folder_cloudIcon;
export const folder_cloud_open = folder_cloud_openIcon;
export const git = gitIcon;
export const graphql = graphqlIcon;
export const html = htmlIcon;
export const javascript = javascriptIcon;
export const javascriptReact = javascriptReactIcon;
export const json = jsonIcon;
export const next = nextIcon;
export const nodejs = nodejsIcon;
export const npm = npmIcon;
export const pnpm = pnpmIcon;
export const prisma = prismaIcon;
export const puppeteer = puppeteerIcon;
export const python = pythonIcon;
export const reactjs = reactjsIcon;
export const robots = robotsIcon;
export const sass = sassIcon;
export const tailwind = tailwindIcon;
export const typescript = typescriptIcon;
export const vercel = vercelIcon;
export const visualStudio = visualStudioIcon;
export const vscode = vscodeIcon;
export const yarn = yarnIcon;

